import { TOSHI_TYPES } from "./environmentVariables";

export const GENERAL_TASK_ROUTE = "GeneralTask";
export const TASK_ROUTE = "Task";
export const INVERSION_SOLUTION_ROUTE = "InversionSolution";
export const FILE_ROUTE = "File";
export const GENERIC_ROUTE = "Generic";
export const FAVOURITES_ROUTE = "Favourites";
export const LOGIC_TREE_ROUTE = "LogicTree";
export const OPENQUAKE_HAZARD_SOLUTION_ROUTE = "OQHazardSolution";

/**
 * Extracts the embedded typename from the `id`
 * @param id a toshi id
 * @returns the typename
 */
export const getToshiType = (id: string | undefined | null) => {
  if (id) {
    try {
      const compoundId = atob(id);
      const toshiType = compoundId.substring(0, compoundId.indexOf(":"));
      if (TOSHI_TYPES.includes(toshiType)) {
        return toshiType;
      }
    } catch {
      return false;
    }
  }
  return false;
};

/**
 * Returns a path to the view for the passed `id` based on the object's type.
 * @param id an object id
 * @returns a string that can be used to link to a view for the object.
 */
export const viewPath = (id: string | undefined | null) => {
  if (id == null || id == undefined) {
    return "";
  }

  // Never build a path from an untrimmed id — whitespace survives into the route
  // param as %20, which the API tolerates but which breaks Relay store lookups.
  const cleanId = id.trim();
  const toshiType = getToshiType(cleanId);

  switch (toshiType) {
    case "GeneralTask":
      return `/${GENERAL_TASK_ROUTE}/${cleanId}`;
    case "AutomationTask":
    case "OpenquakeHazardTask":
    case "RuptureGenerationTask":
      return `/${TASK_ROUTE}/${cleanId}`;
    case "TimeDependentInversionSolution":
    case "ScaledInversionSolution":
    case "InversionSolution":
    case "AggregateInversionSolution":
      return `/${INVERSION_SOLUTION_ROUTE}/${cleanId}`;
    case "File":
    case "RuptureSet":
    case "InversionSolutionNrml":
      return `/${FILE_ROUTE}/${cleanId}`;
    case "OpenquakeHazardSolution":
      return `/${OPENQUAKE_HAZARD_SOLUTION_ROUTE}/${cleanId}`;
    default:
      return `/${GENERIC_ROUTE}/${cleanId}`;
  }
};
